import React, { useEffect } from 'react';
import { useAppDispatch } from '../../../redux/hooks';
import { clearWorkspaces } from '../../../redux/slices/workspaces';
import { SecondaryNavContainer } from '../../../components/SecondaryNav';
import WorkspaceNavLinks from './WorkspaceNavLinks';

export default () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(clearWorkspaces());
    };
  }, [dispatch]);

  return (
    <SecondaryNavContainer>
      <WorkspaceNavLinks />
    </SecondaryNavContainer>
  );
};
